import type { WorkflowActionableType } from '@/api/entity_types/workflow/WorkflowDefinition';
import { useCurrentWorkflowStore } from '@/stores/workflow/currentWorkflow';
import { computed } from 'vue';

export const useResourcesLinks = () => {
  type ResourceLink = {
    url: string;
    label: string;
  };

  const workflowStore = useCurrentWorkflowStore();

  const currentResourceLinks = computed(() => {
    const actions = workflowStore.currentWorkflow.workflow_actions;
    const uniqueActions = [...new Set(actions.map(action => action.workflow_actionable_type))];
    return uniqueActions.map(actionType => resourceLinkMap.get(actionType)).filter(resource => resource !== undefined);
  });

  const resourceLinkMap = new Map<WorkflowActionableType, ResourceLink>([
    ['WorkflowActionEmail', { url: '/settings/templates/email', label: 'Manage Email Templates' }],
    ['WorkflowActionSms', { url: '/settings/templates/sms', label: 'Manage Sms Templates' }],
  ]);

  return { currentResourceLinks };
};
